import { Table } from "antd";
import { useTranslation } from "react-i18next";
import { BsCircleFill } from "react-icons/bs";
import { MdOutlineDeleteOutline, MdOutlineOpenInNew } from "react-icons/md";
import Pagination from "shared/components/Pagination";
import { NAME_SPACES } from "shared/locales/constants";
import { COLORS } from "shared/style/colors";
import { USER_TYPES } from "utils/constants";

const List = ({ data, onDetail, onDelete, count, setValues, skip }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.COLLABORATOR);
  const LIST = t("LIST", { returnObjects: true });

  const STATUS = {
    [USER_TYPES.BROKER_REPRESENTATIVE.type]: (
      <div className="d-flex align--center">
        <BsCircleFill color={COLORS.C_FEMALE} />
        <span>{LIST.REPRESENTATIVE}</span>
      </div>
    ),
    [USER_TYPES.INSURANCE_REPRESENTATIVE.type]: (
      <div className="d-flex align--center">
        <BsCircleFill color={COLORS.C_FEMALE} />
        <span>{LIST.REPRESENTATIVE}</span>
      </div>
    ),
    [USER_TYPES.BROKER_EMPLOYEE.type]: (
      <div className="d-flex align--center">
        <BsCircleFill color={COLORS.C_MALE} />
        <span>{LIST.EMPLOYEE}</span>
      </div>
    ),
    [USER_TYPES.INTERNAL_ADVISOR.type]: (
      <div className="d-flex align--center">
        <BsCircleFill color={COLORS.C_FEMALE} />
        <span>{LIST.ADVISOR}</span>
      </div>
    ),
  };

  const columns = [
    {
      title: LIST.STATUS,
      dataIndex: "meta",
      render: (record) => STATUS[record?.type] || "-",
    },
    {
      title: LIST.CIVILITY,
      dataIndex: "gender",
    },
    {
      title: LIST.FIRST_NAME,
      dataIndex: "firstname",
    },
    {
      title: LIST.LAST_NAME,
      dataIndex: "lastname",
    },
    {
      title: LIST.EMAIL,
      dataIndex: "email",
      render: (email) => <span className="c-text">{email}</span>,
    },
    {
      title: LIST.ACTIONS,
      dataIndex: "id",
      align: "right",
      render: (id) => (
        <div className="d-flex justify--end">
          <MdOutlineOpenInNew
            size={24}
            color={COLORS.C_PRIMARY}
            onClick={() => onDetail(id)}
          />
          <MdOutlineDeleteOutline
            size={24}
            color={COLORS.C_DANGER}
            onClick={() => onDelete(id)}
          />
        </div>
      ),
    },
  ];

  return (
    <>
      <Table
        dataSource={data}
        columns={columns}
        className="table__wrapper"
        rowKey={"id"}
        pagination={false}
        scroll={{ x: true }}
      />
      <Pagination count={count} setValues={setValues} skip={skip} />
    </>
  );
};

export default List;
